import { GreenCheck, OrangeSettings, UpBlue } from '@assets/icons';
import { Colors } from '@constants/colors.constants';
import { Box, styled } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { StatusActivity } from '@store/audits/audit-offer-followUp/audit-offer-followUp.model';


export interface LogoModel {
  status: StatusActivity;
  color: string;
  colorWithOpacity: string;
  logo: any;
}

const TagReference: LogoModel[] = [
  {
    status: StatusActivity.VALIDATED,
    color: Colors.success,
    colorWithOpacity: alpha(Colors.success, 0.14),
    logo: GreenCheck,
  },
  {
    status: StatusActivity.SENT,
    color: Colors.info,
    colorWithOpacity: alpha(Colors.info, 0.14),
    logo: UpBlue,
  },
  {
    status: StatusActivity.ANSWERED,
    color: Colors.warning,
    colorWithOpacity: alpha(Colors.warning, 0.14),
    logo: OrangeSettings,
  },
];

const ActivityTagItemStyled = styled(Box)<{ logo: LogoModel }>((props) => {
  const { logo } = props;
  return {
    backgroundColor: logo?.colorWithOpacity,
    borderRadius: '100px',
    width: '40px',
    height: '40px',
    padding: '3px 10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& svg': {
      width: '13px',
      height: '13px',
    },
  };
});

const ActivityLogoItem = (props: { logoStatus: StatusActivity }) => {
  const { logoStatus } = props;
  const logoModel = TagReference.find((logoModel) => logoModel.status === logoStatus);
  if (!logoModel) { return null; }
  return (
    <ActivityTagItemStyled logo={logoModel}>
      <logoModel.logo />
    </ActivityTagItemStyled>
  );
};

export default ActivityLogoItem;
